import log from "logbeacon";
import type { ConfirmSharpenScoreArgs } from "@/src/components/Chat/InteractiveTool/types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * 解析 confirm_sharpen_score interactive tool args。
 * @see fe-spec-edg-118 §2.2
 */
export function parseConfirmSharpenArgs(
  raw: unknown,
): ConfirmSharpenScoreArgs | null {
  if (!isRecord(raw)) {
    return null;
  }

  const summary = typeof raw.summary === "string" ? raw.summary.trim() : "";
  if (!summary) {
    if (process.env.NODE_ENV !== "production") {
      log.warn("[parseConfirmSharpenArgs] missing summary", raw);
    }
    return null;
  }

  const facts = isRecord(raw.facts)
    ? (raw.facts as ConfirmSharpenScoreArgs["facts"])
    : {};

  return { summary, facts };
}
